import { SentryPackageType, SentryTagKeys } from '@lightdash/common';
import {
    browserTracingIntegration,
    init,
    replayIntegration,
    setTag,
} from '@sentry/react';
import { useEffect, useState } from 'react';

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
const mode = import.meta.env.MODE;

const useSentry = () => {
    const [isSentryLoaded, setIsSentryLoaded] = useState(false);
    useEffect(() => {
        if (sentryDsn && !isSentryLoaded && mode === 'production') {
            init({
                dsn: sentryDsn,
                environment: mode,
                integrations: [
                    browserTracingIntegration(),
                    replayIntegration(),
                ],
                tracesSampler(samplingContext) {
                    if (samplingContext.parentSampled !== undefined) {
                        return samplingContext.parentSampled;
                    }
                    return 0.1;
                },
                replaysOnErrorSampleRate: 1.0,
            });
            setIsSentryLoaded(true);
            setTag(SentryTagKeys.package, SentryPackageType.publicPages);
        }
    }, [isSentryLoaded, setIsSentryLoaded]);
};

export default useSentry;
